import { createApp } from 'vue';
import PdfToPdfAConverter from '@/Components/PdfToPdfAConverter.vue';
import '@styles/app.css';

createApp(PdfToPdfAConverter).mount('#pdf-to-pdfa-converter');
